// @mui
import Button from '@mui/material/Button';
import { SxProps, Theme } from '@mui/material/styles';
// routes
import { RouterLink } from 'src/routes/components';
// auth
import { Typography } from '@mui/material';

type Props = {
  sx?: SxProps<Theme>;
};

export default function LoginButton({ sx }: Props) {
  const loginPath = 'https://app.salonify.gr/';

  return (
    <Button component={RouterLink} href={loginPath} variant="outlined" sx={{ mr: 1, ...sx }}>
      <Typography>Είσοδος</Typography>
    </Button>
  );
}
